export class ScriptLoadError extends Error {
  constructor(url: string) {
    super(url);
    this.name = 'ScriptLoadError';
  }
}

const noop = () => {};

function renderScript(
  path: string,
  useModule: boolean,
  onSuccess: () => void = noop,
  onError: (error: ScriptLoadError) => void = noop
) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = path;
  script.async = true;
  if (useModule) {
    script.type = 'module';
  }
  script.onload = onSuccess;

  script.onerror = () => {
    onError(new ScriptLoadError(path));
  };

  document.body.appendChild(script);
}

function loadScript(path: string, useModule = false) {
  return new Promise<void>((resolve, reject) =>
    renderScript(path, useModule, resolve, reject)
  );
}

export { loadScript };
